import React, { Fragment, useState } from "react";
import { useHistory } from "react-router-dom";

import MUIDataTable, { FilterType } from "mui-datatables";
import { IconButton, Tooltip, Typography } from "@material-ui/core";
import Add from "@material-ui/icons/Add";

export const ChoicesTable = ({
  currentActivity,
  displayGroupId,
  displayIndex,
  activityId,
}) => {
  const history = useHistory();

  const options = {
    responsive: "standard",
    fixedHeader: true,
    fixedSelectColumn: true,
    download: false,
    filterType: "multiselect",
    onRowClick: (a, b) => {
      //Retrieve the original object ID from the data list.
      var choiceName = currentActivity.Choices[b.dataIndex].Name;
      history.push(
        `/my-displays-maintenance/${displayGroupId}/${displayIndex}/${activityId}/choice/${choiceName}`
      );
    },
    pagination: false,
    print: false,
    searchPlaceholder: "Search By Any Field",
    selectableRows: "none",
  };

  options.customToolbar = () => {
    return (
      <Fragment>
        <Tooltip title="Add New Choice">
          <IconButton
            onClick={() =>
              history.push(
                `/my-displays-maintenance/${displayGroupId}/${displayIndex}/${activityId}/choice/new`
              )
            }
          >
            <Add />
          </IconButton>
        </Tooltip>
      </Fragment>
    );
  };

  const columns = [
    {
      name: "Name",
      label: "Name",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => {
          return <Typography>{value}</Typography>;
        },
      },
    },
    {
      name: "Weight",
      label: "Weight",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => {
          return <Typography>{value}</Typography>;
        },
      },
    },
    {
      name: "IsActive",
      label: "Active",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => {
          const isActiveElement =
            value === true ? (
              <span className="active-tag-text">Active</span>
            ) : (
              <span className="inactive-tag-text">Inactive</span>
            );
          return <>{isActiveElement}</>;
        },
      },
    },
  ];

  return (
    <>
      <MUIDataTable
        title={"Choices"}
        data={currentActivity.Choices}
        columns={columns}
        options={options}
      />
    </>
  );
};
